import gql from 'graphql-tag';
import FieldsCredit from 'graphql/fields/FieldsCredit';

export default gql(`
	query employee_credits {
		employee_credits {
			${FieldsCredit}
		}
	}
`);

